module.exports = __webpack_public_path__ + "media/images/icon/bathroom-5f00a1af04136ff2f0f6ce3ba012aa4d.svg";